import React, { Fragment } from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import { filterTermsBySlug } from 'util/terms';
import { getLinkProps, getTagPath } from 'util/link';
import Link from 'components/Link';
import styles from './styles';

function PostTags({ tags, whitelist, limit }) {
  // Filter categories and tags using the whitelist (if provided)
  const safeTags = whitelist ? filterTermsBySlug(tags, whitelist.tags) : tags;

  return (
    <Fragment>
      <style jsx>{styles}</style>
      {safeTags.slice(0, limit).map(tag => (
        <div className="Post__tag" key={tag.slug}>
          <Link {...getLinkProps(getTagPath(tag))}>
            <a
              className="Post__tag-link"
              dangerouslySetInnerHTML={{ __html: tag.name }}
            />
          </Link>
        </div>
      ))}
    </Fragment>
  );
}

PostTags.propTypes = {
  tags: arrayOf(
    shape({
      name: string,
      slug: string
    })
  ),
  limit: number,
  whitelist: shape({
    categories: arrayOf(string),
    tags: arrayOf(string),
    subtitle: arrayOf(string)
  })
};

PostTags.defaultProps = {
  tags: [],
  limit: 2,
  whitelist: undefined
};

export default PostTags;
